import React from 'react';
import Backend from '../../../Layouts/Backend';
import { Formik } from 'formik';
import PasswordConfirmation from '../../../UI/PasswordConfirmation';
import { Form } from 'reactstrap';
import { Alert, Input, Checkbox, Button, Dropdown } from '../../../UI/Common';
import { validationSchema } from './validation';
import { withTranslation } from 'react-i18next';
import helper from '../../../../utils/helper';

function MobileConfigurationForm({ t, isCopy, ...props }) {
  const roleNames =
    JSON.parse(localStorage.getItem('userProfile')).roleNames || [];
  const isAdmin = roleNames.includes('admin') || roleNames.includes('Admin');
  const [openModal, setOpenModal] = React.useState(false);
  const isRequireConfirmation = helper.isRequireConfirmation();
  function onSubmit(values) {
    if (isRequireConfirmation) {
      setOpenModal(true);
    } else {
      props.onSubmit(values);
    }
  }
  function getTitle() {
    if (props.isEdit)
      return `Edit Mobile Configuration: ${props.initialValues.name || ''}`;
  }
  return (
    <Backend title={getTitle()}>
      <Formik
        initialValues={props.initialValues}
        enableReinitialize
        validationSchema={validationSchema(isCopy, isAdmin)}
        onSubmit={onSubmit}
      >
        {({
          values,
          handleChange,
          touched,
          errors,
          setFieldValue,
          handleSubmit,
        }) => {
          return (
            <div className="content-inner">
              <Alert.Error text={props.errors} />
              <PasswordConfirmation
                isOpen={openModal}
                onCancel={() => setOpenModal(false)}
                onConfirm={() => {
                  setOpenModal(false);
                  props.onSubmit(values);
                }}
              />
              <Form className="w-50">
                {isAdmin ? (
                  <Checkbox
                    id="accessibleTypes"
                    label="Private"
                    checked={values.accessibleTypes}
                    onChange={(isCheck) =>
                      setFieldValue('accessibleTypes', isCheck)
                    }
                  />
                ) : null}
                {isAdmin && isCopy ? (
                  <Dropdown
                    type="dynamic"
                    required
                    label="Username"
                    data={props.users}
                    value={values.desiredUserId}
                    onChange={({ value, text }) => {
                      setFieldValue('desiredUserId', value);
                      setFieldValue('userName', text);
                      setTimeout(() => {
                        setFieldValue('desiredUserId', value);
                        setFieldValue('userName', text);
                      });
                    }}
                    valueKey="id"
                    nameKey="email"
                    subtitleKey="id"
                    invalid={touched.desiredUserId}
                    error={errors.desiredUserId}
                  />
                ) : null}
                <Input
                  required
                  id="name"
                  label="Name"
                  value={values.name}
                  onChange={handleChange('name')}
                  invalid={touched.name}
                  error={errors.name}
                />
                <Checkbox
                  id="alertsOnly"
                  label="Alerts Only?"
                  checked={values.alertsOnly}
                  onChange={(isCheck) => setFieldValue('alertsOnly', isCheck)}
                />
                <Input
                  required
                  type="number"
                  id="scrollTopMin"
                  label="Scroll To Top (Minutes)"
                  value={values.scrollTopMin}
                  onChange={handleChange('scrollTopMin')}
                  invalid={touched.scrollTopMin}
                  error={errors.scrollTopMin}
                />
                <Checkbox
                  id="sortByAlarmPriority"
                  label="Sort By Alarm Priority"
                  checked={values.sortByAlarmPriority}
                  onChange={(isCheck) =>
                    setFieldValue('sortByAlarmPriority', isCheck)
                  }
                />
                <Button
                  id="create-edit-mobile-config"
                  loading={props.submitting}
                  onClick={handleSubmit}
                >
                  <i className="md-icon">done</i>
                  {t(props.isEdit ? 'Save' : 'Create')}
                </Button>
              </Form>
            </div>
          );
        }}
      </Formik>
    </Backend>
  );
}

export default withTranslation('app')(MobileConfigurationForm);
